module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('van-search', {
    attrs: {
      "placeholder": "请输入搜索关键词",
      "show-action": "",
      "shape": "round"
    },
    on: {
      "keyup": _vm.onChange,
      "search": _vm.onSearch
    },
    model: {
      value: (_vm.params.keywords),
      callback: function($$v) {
        _vm.$set(_vm.params, "keywords", $$v)
      },
      expression: "params.keywords"
    }
  }, [_c('div', {
    attrs: {
      "slot": "action"
    },
    on: {
      "click": _vm.onSearch
    },
    slot: "action"
  }, [_vm._v("搜索")])]), _vm._v(" "), _c('van-pull-refresh', {
    on: {
      "refresh": _vm.onRefresh
    },
    model: {
      value: (_vm.loadingFresh),
      callback: function($$v) {
        _vm.loadingFresh = $$v
      },
      expression: "loadingFresh"
    }
  }, [_c('van-list', {
    attrs: {
      "finished": _vm.noMore,
      "finished-text": "没有更多了"
    },
    on: {
      "load": _vm.onLoad
    },
    model: {
      value: (_vm.loadingMore),
      callback: function($$v) {
        _vm.loadingMore = $$v
      },
      expression: "loadingMore"
    }
  }, [_c('div', {
    staticStyle: {
      "padding-top": "15px"
    }
  }), _vm._v(" "), (!_vm.params.keywords) ? _c('div', {
    staticClass: "search-tip"
  }, [_c('div', {
    staticClass: "search-tip-title"
  }, [_vm._v("热门搜索")]), _vm._v(" "), _c('div', {
    staticClass: "search-tip-wrap"
  }, _vm._l((_vm.keywordsList), function(item, index) {
    return _c('div', {
      on: {
        "click": function($event) {
          return _vm.onSelect(item)
        }
      }
    }, [_vm._v(_vm._s(item))])
  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.params.keywords) ? _c('div', [_c('GoodsItems', {
    attrs: {
      "goodsList": _vm.list
    }
  })], 1) : _vm._e()])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-178c22d2","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/index/Search.vue
// module id = 2234
// module chunks = 0